import { noticeFailure } from "@self/notices";
import { makeStylesheetLink } from "@self/stylesheet";

export class LogIn extends HTMLElement {

	shadow: ShadowRoot;

	email: HTMLInputElement;
	password: HTMLInputElement;

	button: HTMLButtonElement;

	form: HTMLFormElement;

	forgotPasswordLink: HTMLAnchorElement;

	onClick: (event: Event) => void;

	static get observedAttributes() {
		return ["email", "password"] as const;
	}

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.email = <input
			type="email"
			value={this.getAttribute("email") ?? ""}
			className="gct-w100"
			placeholder=" "
		/> as HTMLInputElement;

		this.password = <input
			type="password"
			value={this.getAttribute("password") ?? ""}
			className="gct-w100"
			placeholder=" "
		/> as HTMLInputElement;

		this.button = (
			<button type="submit" className="gct-btn-lg">
				Log in
			</button>
		) as HTMLButtonElement;

		this.forgotPasswordLink = (
			<a className="gct-link gct-content-fit">
				Have you forgotten your password?
			</a>
		) as HTMLAnchorElement;

		this.onClick = onClick.bind(this);

		this.form = (
			<form className="gct-flex-column gct-gap-40">
				<div class="gct-h3">Log in to your account</div>
				<div className="gct-flex-column gct-gap-24">
					<div className="gct-p-relative gct-w100">
						{this.email}
						<label className="gct-input-label">E-mail</label>
					</div>
					<div className="gct-p-relative gct-w100">
						{this.password}
						<label className="gct-input-label">Password</label>
					</div>
				</div>
				<div className="gct-flex-column gct-gap-24">
					{this.button}
					{this.forgotPasswordLink}
				</div>
			</form>
		) as HTMLFormElement;

		this.shadow.append(
			this.form,
			makeStylesheetLink(),
		);
	}

	connectedCallback() {
		this.forgotPasswordLink.href = this.dataset.forgotPasswordUrl ?? "#";
		this.form.addEventListener("submit", this.onClick);
	}

	disconnectedCallback() {
		this.form.removeEventListener("submit", this.onClick);
	}
}

async function onClick(this: LogIn, event: Event) {
	event.preventDefault();

	try {
		this.button.disabled = true;
		this.email.disabled = true;
		this.password.disabled = true;

		const email = this.email.value;
		const password = this.password.value;

		const data = new URLSearchParams({
			log: email,
			pwd: password,
			redirect_to: this.dataset.redirectTo!
		});

		data.append("_wpnonce", this.dataset.nonce || "");
		data.append("woocommerce-login", "1");

		const res = await fetch(this.dataset.endpoint!, {
			method: "POST",
			body: data,
			credentials: "include",
		});

		if (res.ok) {
			window.location.href = this.dataset.redirectTo!;
		} else {
			noticeFailure("Login failed. Please try again.");
		}
	} catch (error) {
		if (error instanceof TypeError) {
			noticeFailure("Couldn't connect. Are you online?");
		} else {
			noticeFailure("There was an unexpected error.")
		}
	} finally {
		this.button.disabled = false;
		this.email.disabled = false;
		this.password.disabled = false;
	}
}
